import type { UpdateOneWorkflowDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useInvalidateWorkflowListQuery } from "./use-workflows-query";
import { useApiMutation } from "./use-api-mutation";

export default function useEditWorkflow(shopId: string) {
	const invalidateShop = useInvalidateShop(shopId);
	const invalidateWorkflowListQuery = useInvalidateWorkflowListQuery(shopId);

	return useApiMutation(
		"patch",
		"/shops/{shopId}/workflows/{workflowId}",
		{
			invalidate: [invalidateShop, invalidateWorkflowListQuery],
			mapVariables: ({
				body,
				workflowId,
			}: {
				body: UpdateOneWorkflowDto;
				workflowId: string;
			}) => ({
				params: { path: { shopId, workflowId } },
				body,
			}),
		},
	);
}
